import { QrCode } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeRegistrationProps {
  qrCodeUrl: string;
  deviceId: string;
  onUrlCopy: (message: string) => void;
  screenHeight: number;
  screenWidth: number;
}

const QRCodeRegistration: React.FC<QRCodeRegistrationProps> = ({
  qrCodeUrl,
  deviceId,
  onUrlCopy,
  screenHeight,
  screenWidth,
}) => {
  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center p-2">
      <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl w-full max-w-4xl mx-auto p-4 sm:p-6">
        
        {/* Header */}
        <div className="text-center text-white mb-4">
          <QrCode className="w-12 h-12 mx-auto text-blue-400 mb-2" />
          <h1 className="text-xl sm:text-2xl font-bold text-blue-200 mb-1">
            Device Registration
          </h1>
          <p className="text-sm sm:text-base text-blue-200">
            Enter this code to register your device
          </p>
        </div>

        {/* Device Code */}
        <div className="text-center mb-4">
          <div className="flex justify-center gap-2 mb-2">
            {deviceId.split('').map((digit, index) => (
              <div
                key={index}
                className="bg-white border-2 border-white rounded-xl px-3 py-2 shadow-2xl"
              >
                <span className="text-2xl sm:text-3xl text-gray-800 font-bold">
                  {digit}
                </span>
              </div>
            ))}
          </div>
          <p className="text-sm sm:text-base text-blue-200 font-medium">
            or scan QR code
          </p>
        </div>

        {/* QR Code and Screen Info */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          
          {/* QR Code */}
          <div className="bg-white p-3 rounded-xl shadow-2xl">
            <QRCodeSVG
              value={qrCodeUrl}
              size={120}
              level="H"
              className="block"
            />
          </div>

          {/* Screen Resolution */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-3 text-center">
            <p className="text-sm text-blue-200 font-medium mb-2">
              Screen Resolution
            </p>
            <div className="flex items-center justify-center gap-3">
              <div>
                <div className="text-xl sm:text-2xl font-bold text-white">
                  {screenWidth}
                </div>
                <div className="text-xs text-blue-300">Width</div>
              </div>
              <div className="text-xl sm:text-2xl text-blue-400">
                ×
              </div>
              <div>
                <div className="text-xl sm:text-2xl font-bold text-white">
                  {screenHeight}
                </div>
                <div className="text-xs text-blue-300">Height</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeRegistration;
